<template>
  <div class="materialMaterial">
    <div>
      <el-row :gutter="20">
        <el-col :sm="12" :md="6" :lg="4">
          <el-button
          :disabled="!canUp"
            type="primary"
            @click="materialVisible = true"
            v-auth="'material_/attachment/addAttachment'"
            >上传讲义</el-button
          >
        </el-col>
        <el-col
          :sm="12"
          :md="18"
          :lg="20"
          style="text-align: right"
          v-auth="'material_/attachment/pageList'"
        >
          <el-input
            style="width: 200px; margin-right: 10px"
            placeholder="请输入讲义名称"
            auto-complete="off"
            v-model="searchForm.name"
            clearable
            @keyup.enter.native=";(page.pageNumber = 1), pageList()"
          >
          </el-input>
          <el-button type="primary" @click=";(page.pageNumber = 1), pageList()"
            >查询</el-button
          >
        </el-col>
      </el-row>
    </div>
    <div
      style="display: flex; margin-top: 10px"
      v-auth="'material_/attachment/pageList'"
    >
      <div class="materialMaterial-left" :style="{ width: width + 'px' }">
        <div class="materialMaterial-left-title">
          讲义分组
          <span
            v-auth="'material_/fodderGroupInfo/addFodderGroupInfo'"
            @click="
              addForm.parentId = 0
              groupsVisible = true
            "
            class="iconPlus operItem el-icon-plus"
          ></span>
        </div>
        <div class="materialMaterial-left-input">
          <el-input
            placeholder="请输入分组名称"
            v-model="searchFodderGroupForm.name"
            auto-complete="off"
            @keyup.enter.native="getFodderGroupInfoTree"
          >
            <i
              class="el-icon-search el-input__icon"
              slot="suffix"
              @click="getFodderGroupInfoTree"
            ></i>
          </el-input>
        </div>
        <el-tree
          :data="fodderGroupInfoList"
          :props="defaultProps"
          :highlight-current="true"
          :expand-on-click-node="false"
          class="research-tree"
          ref="tree"
          node-key="id"
          current-node-key
        >
          <span class="span-ellipsis" slot-scope="{ node, data }">
            <span @click="treeClick(data)">
              <i
                style="color: #409eff; font-size: 14px"
                class="icon iconfont icon-wenjian"
              ></i>
              <span style="margin-left: 10px">{{ data.name }}</span>
              <div
                class="material_operation"
                v-if="data.name !== '全部讲义' && data.name !== '默认分组'"
              >
                <span
                  v-auth="'material_/fodderGroupInfo/addFodderGroupInfo'"
                  style="font-size: 16px"
                  @click="
                    addForm.parentId = data.id
                    groupsVisible = true
                  "
                  class="el-icon-circle-plus-outline"
                ></span>
                <el-dropdown v-auth="'material_elDropdown'">
                  <div class="el-dropdown-link">
                    <span
                      style="font-size: 16px; color: #409eff"
                      class="el-icon-more"
                    ></span>
                  </div>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      style="font-size: 12px"
                      @click.native="rename(data)"
                      >重命名</el-dropdown-item
                    >
                    <el-dropdown-item
                      style="font-size: 12px"
                      @click.native="deleteFodderGroupInfo(data.id)"
                      >删除分组</el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </span>
          </span>
        </el-tree>
      </div>
      <XHandle class="myxhandle" @widthChange="widthChange" />
      <div class="materialMaterial-right">
        <el-table
          ref="multipleTable"
          v-loading="loading"
          element-loading-text="拼命加载中"
          element-loading-background="rgba(255, 255, 255, 0.8)"
          :data="page.rows"
          tooltip-effect="dark"
          style="margin-top: 0px; width: 100%"
          border
          @selection-change="materialSelectionChange"
        >
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column
            prop="name"
            label="讲义"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <i
                :class="'iconfont ' + setIcon(scope.row.name)"
                :style="'font-size: 16px;;color:' + setColor(scope.row.name)"
              ></i>
              <span>{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="size" label="大小" width="180">
            <template slot-scope="scope"
              >{{ (scope.row.size / 1024 / 1024).toFixed(4) }}MB</template
            >
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="上传时间"
            width="180"
          ></el-table-column>
          <!-- <el-table-column prop="state" label="状态" width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.state==1">正常</span>
              <span v-else>异常</span>
            </template>
          </el-table-column> -->
          <el-table-column prop label="操作" width="160" align="center">
            <template slot-scope="scope">
              <div class="operationGroup">
                <span
                  class="operation-style"
                  @click="edit(scope.row)"
                  v-auth="'material_/fodderGroupInfo/updateAttachment'"
                  >编辑</span
                >
                <span
                  class="operation-style"
                  @click="down(scope.row)"
                  v-auth="'material_down'"
                  >下载</span
                >
                <span
                  class="operation-style"
                  @click="deleteVideo(scope.row)"
                  v-auth="'material_/attachment/deleteAttachment'"
                  >删除</span
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div style="display: flex; justify-content: space-between">
          <div style="display: flex; margin-top: 20px; padding: 2px">
            <div style="line-height: 28px; color: #a2aabc; margin-left: 20px">
              已选{{ ids.length }}条
            </div>
            <div
              class="materialMaterial-button"
              @click="delectVideoList()"
              v-auth="'material_/attachment/deleteAttachment'"
            >
              批量删除
            </div>
            <div
              class="materialMaterial-button"
              @click="selectTransferFodder(1)"
              v-auth="'material_/fodderGroupInfo/updateAttachment'"
            >
              移动到
            </div>
            <div
              class="materialMaterial-button"
              @click="selectTransferFodder(2)"
              v-auth="'material_/fodderGroupInfo/updateAttachment'"
            >
              全部移动到
            </div>
          </div>
          <el-pagination
            background
            layout="total, prev, pager, next"
            style="margin-top: 20px; text-align: right"
            :total="page.total"
            :page-size="page.pageSize"
            :current-page="page.pageNumber"
            @size-change="sizeChange"
            @current-change="currentChange"
          ></el-pagination>
        </div>
      </div>
      <el-dialog
        title="上传讲义"
        :visible.sync="materialVisible"
        width="800px"
        left
        :close-on-click-modal="false"
      >
        <el-form
          ref="addmaterialForm"
          :model="addmaterialForm"
          :label-width="formLabelWidth"
          :rules="addmaterialFormRules"
        >
          <el-form-item label="上传到" prop="id">
            <!-- <el-input style="width:100%" v-model="addmaterialForm.name" placeholder="请输入分组名称"></el-input> -->
            <el-cascader
              clearable
              v-model="addmaterialForm.id"
              :show-all-levels="false"
              placeholder="请选择"
              :options="fodderGroupInfoList"
              :props="props"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="本地文件">
            <el-upload
              class="upload-demo"
              ref="upload"
              action
              :http-request="amountFileUploadRequest"
              multiple
            >
              <el-button type="primary" plain slot="trigger"
                >选择文件</el-button
              >
              <span style="margin-left: 10px"
                >1.支持doc，docx，xls，xlsx，ppt，pptx，png，jpg，pdf格式；2.一次最多上传100个文件</span
              >
            </el-upload>
          </el-form-item>
        </el-form>
        <el-table
          ref="multipleTable"
          v-loading="loading"
          element-loading-text="拼命加载中"
          element-loading-background="rgba(255, 255, 255, 0.8)"
          :data="materialList"
          tooltip-effect="dark"
          style="margin-top: 0px; width: 100%"
          border
          @selection-change="selectionChange"
        >
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column prop="name" label="讲义"></el-table-column>
          <el-table-column prop="size" label="大小" width="80">
            <template slot-scope="scope"
              >{{ (scope.row.size / 1024 / 1024).toFixed(4) }}MB</template
            >
          </el-table-column>
          <el-table-column
            prop="percent"
            label="进度"
            width="80"
          ></el-table-column>
          <el-table-column prop label="操作" width="80" align="center">
            <template slot-scope="scope">
              <span class="operation-style" @click="deletematerial(scope.row)"
                >删除</span
              >
            </template>
          </el-table-column>
        </el-table>
        <div style="display: flex; justify-content: space-between">
          <div style="display: flex; margin-top: 5px; padding: 2px">
            <div style="line-height: 28px; color: #a2aabc">
              已选{{ addmaterialForm.attachmentList.length }}条
            </div>
            <div class="photoMaterial-button" @click="deletematerialList()">
              批量删除
            </div>
          </div>
        </div>
        <div slot="footer" class="dialog-footer" style="text-align: right">
          <el-button @click="materialVisible = false">取 消</el-button>
          <el-button
            type="primary"
            @click="addAttachmentmaterial()"
            :loading="addAttachmentmaterialBlock"
            >确 定</el-button
          >
        </div>
      </el-dialog>

      <el-dialog
        title="编辑讲义"
        :visible.sync="editPhotoVisible"
        width="400px"
        left
        :close-on-click-modal="false"
      >
        <el-form
          ref="editPhotoForm"
          :model="editPhotoForm"
          :label-width="formLabelWidth"
          :rules="editPhotoFormRules"
        >
          <el-form-item label="名称" prop="name">
            <el-input
              style="width: 100%"
              v-model="editPhotoForm.name"
              placeholder="请输入图片名称"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: right">
          <el-button @click="editPhotoVisible = false">取 消</el-button>
          <el-button
            type="primary"
            @click="updateAttachment()"
            :loading="updateAttachmentBlock"
            >确 定</el-button
          >
        </div>
      </el-dialog>
      <el-dialog
        title="添加分组"
        :visible.sync="groupsVisible"
        width="400px"
        left
        :close-on-click-modal="false"
      >
        <el-form
          ref="addForm"
          :model="addForm"
          :label-width="formLabelWidth"
          :rules="addFormRules"
        >
          <el-form-item label="分组名称" prop="name">
            <el-input
              style="width: 100%"
              v-model="addForm.name"
              maxlength="10"
              placeholder="请输入分组名称"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: right">
          <el-button @click="groupsVisible = false">取 消</el-button>
          <el-button type="primary" @click="addFodderGroupInfo">确认</el-button>
        </div>
      </el-dialog>
      <el-dialog
        title="素材移动到"
        :visible.sync="moveVisible"
        width="400px"
        left
        :close-on-click-modal="false"
      >
        <el-tree
          :data="fodderGroupInfoList"
          :props="defaultProps"
          :highlight-current="true"
          :expand-on-click-node="false"
          class="research-tree"
          ref="tree"
          node-key="id"
          current-node-key
        >
          <span class="span-ellipsis" slot-scope="{ node, data }">
            <span @click="transferTreeClick(data)">
              <i
                style="color: #409eff; font-size: 14px"
                class="icon iconfont icon-wenjian"
              ></i>
              <span style="margin-left: 10px">{{ data.name }}</span>
            </span>
          </span>
        </el-tree>
        <div slot="footer" class="dialog-footer" style="text-align: right">
          <el-button @click="moveVisible = false">取 消</el-button>
          <el-button type="primary" @click="submit()">确 定</el-button>
        </div>
      </el-dialog>

      <el-dialog
        title="编辑分组名称"
        :visible.sync="editGroupsVisible"
        width="400px"
        left
        :close-on-click-modal="false"
      >
        <el-form
          ref="editGroupsForm"
          :model="editGroupsForm"
          :label-width="formLabelWidth"
          :rules="editGroupsFormRules"
        >
          <el-form-item label="名称" prop="name">
            <el-input
              style="width: 100%"
              v-model="editGroupsForm.name"
              placeholder="请输入分组名称"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: right">
          <el-button @click="editGroupsVisible = false">取 消</el-button>
          <el-button
            type="primary"
            @click="updateFodderGroupInfo()"
            :loading="updateAttachmentBlock"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { uploadTC } from "../../upload/tecent";
import XHandle from "./components/handle";
import axios from "axios";
import { uploadOSS } from "../../upload/upload";
export default {
  components: { XHandle },
  data () {
    return {
      canUp:true,
      addAttachmentmaterialBlock: false,
      width: 300,
      updateAttachmentBlock: false,
      updateFodderGroupInfoBlock: false,
      editPhotoVisible: false,
      editGroupsVisible: false,
      selectSubmit: 1,
      fileActive: 0,
      dialogFileActive: 0,
      groupsVisible: false,
      materialVisible: false,
      moveVisible: false,
      formLabelWidth: "80px",
      materialList: [],
      addForm: {
        name: null,
        parentId: null,
        type: 3,
      },
      addmaterialForm: {
        id: null,
        attachmentList: [],
      },
      editGroupsForm: {},
      editPhotoForm: {},
      fodderGroupInfoList: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      props: {
        value: "id",
        children: "children",
        label: "name",
      },
      searchForm: {
        type: 3,
        fodderGroupInfoId: null,
        name: null,
      },
      searchFodderGroupForm: {
        type: 3,
        name: null,
      },
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      colorList: {
        img: {
          color: "rgb(232, 145, 49)",
          icon: "icon-png",
        },
        txt: {
          color: "rgb(51, 51, 51)",
          icon: "icon-text",
        },
        mp4: {
          color: "rgb(243, 177, 55);",
          icon: "icon-mp1",
        },
        mp3: {
          color: "rgb(241, 109, 0);",
          icon: "icon-mp",
        },
        none: {
          color: "",
          icon: "icon-wukong",
        },

        pdf: {
          color: "rgb(220,46,27)",
          icon: "icon-pdf",
        },
        docx: {
          color: "rgb(58,128,252)",
          icon: "icon-docx",
        },
        ppt: {
          color: "rgb(243,78,25)",
          icon: "icon-ppt",
        },
        pptx: {
          color: "rgb(243,78,25)",
          icon: "icon-ppt",
        },
        xlsx: {
          color: "rgb(3,158,25)",
          icon: "icon-xlsx",
        },
      },
      addFormRules: {
        name: [
          {
            required: true,
            message: "请输入分组名称",
            trigger: "blur",
          },
          {
            min: 1,
            max: 10,
            message: "分组名称长度在1到10个字",
          },
        ],
      },
      addmaterialFormRules: {
        id: {
          required: true,
          message: "请选择分组",
          trigger: "change",
        },
      },

      editPhotoFormRules: {
        name: [
          {
            required: true,
            message: "请输入分组名称",
            trigger: "blur",
          },
          {
            min: 1,
            max: 10,
            message: "分组名称长度在1到10个字",
          },
        ],
      },

      editGroupsFormRules: {
        name: [
          {
            required: true,
            message: "请输入分组名称",
            trigger: "blur",
          },
          {
            min: 1,
            max: 10,
            message: "分组名称长度在1到10个字",
          },
        ],
      },
      loading: false,
      id: null,
      ids: [],
      fodderGroupInfoName: name,
      fodderGroupInfoId: null,
    };
  },
  methods: {
    widthChange (movement) {
      console.log(movement, "~~~");
      this.width -= movement;
      if (this.width < 300) {
        this.width = 300;
      }
      if (this.width > 700) {
        this.width = 695;
      }
    },
    /*---------------------------pagelist操作-------------------------*/
    treeClick (data) {
      this.id = data.id;
      this.fodderGroupInfoName = data.name;
      if (data.name == "全部讲义") {
        this.searchForm.fodderGroupInfoId = "";
      } else {
        this.searchForm.fodderGroupInfoId = data.id;
      }
      this.pageList();
    },
    sizeChange (pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange (pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    pageList () {
      this.loading = true;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.api.attachment
        .pageList(this.searchForm)
        .then((result) => {
          this.loading = false;
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
          this.$emit("attachmentSizeChange", true);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    setIcon (val) {
      let str = val.toString().split(".");
      let arr = ["png", "jpg", "jpeg", "gif", "ico"];
      if (arr.indexOf(str[str.length - 1]) != -1) {
        str[str.length - 1] = "img";
      }
      if (this.colorList[str[str.length - 1]]) {
        return this.colorList[str[str.length - 1]].icon;
      } else {
        return this.colorList.none.icon;
      }
    },
    setColor (val) {
      let str = val.toString().split(".");
      let arr = ["png", "jpg", "jpeg", "gif", "ico"];
      if (arr.indexOf(str[str.length - 1]) != -1) {
        str[str.length - 1] = "img";
      }

      if (this.colorList[str[str.length - 1]])
        return this.colorList[str[str.length - 1]].color;
      else {
        return this.colorList.none.color;
      }
    },

    materialSelectionChange (val) {
      this.ids = [];
      let obj = {};
      val.forEach((e) => {
        this.ids.push({ id: e.id });
      });
    },

    edit (row) {
      this.editPhotoForm = row;
      this.editPhotoVisible = true;
    },

    updateAttachment () {
      if (this.updateAttachmentBlock) {
        return;
      }
      this.updateAttachmentBlock = true;
      this.api.fodderGroupInfo.updateAttachment(this.editPhotoForm).then((res) => {
        if (res.success) {
          this.updateAttachmentBlock = false;
          this.editPhotoVisible = false;
          this.pageList();
        } else {
          this.updateAttachmentBlock = false;
          this.$message.success(res.message);
        }
      });
    },

    down (row) {
      window.open(row.url);
    },

    deleteVideo (row) {
      this.$confirm("将会删除该讲义，是否确认删除？", "系统消息", {
        type: "warning",
      }).then(() => {
        let obj = {
          id: row.id,
        };
        this.api.attachment.deleteAttachment([obj]).then((res) => {
          if (res.success) {
            this.$message.success(res.message);
            this.pageList();
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },

    delectVideoList () {
      if (this.ids.length == 0) {
        this.$message.warning("请选择需要删除的讲义！");
      } else {
        this.$confirm("将会删除选中讲义，是否确认删除？", "系统消息", {
          type: "warning",
        }).then(() => {
          this.api.attachment.deleteAttachment(this.ids).then((res) => {
            if (res.success) {
              this.$message.success(res.message);
              this.pageList();
            } else {
              this.$message.error(res.message);
            }
          });
        });
      }
    },

    selectTransferFodder (num) {
      if (num == 1) {
        if (this.ids.length == 0) {
          this.$message.warning("请选中需要移动的讲义！");
        } else {
          this.moveVisible = true;
        }
      } else {
        if (
          this.fodderGroupInfoName == "全部讲义" ||
          this.fodderGroupInfoName == "默认分组"
        ) {
          this.$message.warning("默认分组不可以转移讲义！");
        } else {
          this.moveVisible = true;
        }
      }
      this.selectSubmit = num;
    },

    transferTreeClick (data) {
      this.fodderGroupInfoId = data.id;
    },

    submit () {
      if (this.selectSubmit == 1) {
        this.transferFodder();
      } else {
        this.transferFodderByFodderGroupInfoId();
      }
    },

    transferFodder () {
      if (this.fodderGroupInfoId == null || this.fodderGroupInfoId == "") {
        this.$message.error("请选择分组！");
        return;
      }
      let obj = {
        id: this.fodderGroupInfoId,
        attachmentList: this.ids,
      };
      this.api.fodderGroupInfo.transferFodder(obj).then((res) => {
        if (res.success) {
          this.$message.success(res.message);
          this.page.pageNumber = 1;
          this.pageList();
          this.moveVisible = false;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    transferFodderByFodderGroupInfoId () {
      if (this.fodderGroupInfoId == null || this.fodderGroupInfoId == "") {
        this.$message.error("请选择分组！");
        return;
      }
      let obj = {
        fodderGroupInfoId: this.fodderGroupInfoId,
        id: this.id,
      };
      this.api.fodderGroupInfo.transferFodderByFodderGroupInfoId(obj).then((res) => {
        if (res.success) {
          this.$message.success(res.message);
          this.page.pageNumber = 1;
          this.pageList();
          this.moveVisible = false;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /*---------------------------上传讲义-------------------------*/

    amountFileUploadRequest (file) {
      if (file.file.size / 1024 / 1024 > 100) {
        this.$message.error("讲义大小不能超过100M");
      } else {
        uploadOSS(file, "materials").then((result) => {
          let obj = {
            name: file.file.name,
            size: file.file.size,
            type: file.file.type,
            url: result,
            percent: "100%",
          };
          this.materialList.push(obj);
        });
      }
    },

    selectionChange (val) {
      this.addmaterialForm.attachmentList = val;
    },

    deletematerial (row) {
      this.$confirm("将会删除该讲义，是否确认删除？", "系统消息", {
        type: "warning",
      }).then(() => {
        this.materialList.forEach((item, index) => {
          if (row.fileId == item.fileId) {
            this.materialList.splice(index, 1);
          }
        });
      });
    },

    deletematerialList () {
      this.$confirm("将会删除选中视频，是否确认删除？", "系统消息", {
        type: "warning",
      }).then(() => {
        this.addTecentVideoForm.fileIds.forEach((e) => {
          this.videoMaterialList.forEach((item, index) => {
            if (e == item.fileId) {
              this.videoMaterialList.splice(index, 1);
            }
          });
        });
      });
    },

    addAttachmentmaterial () {
      this.$refs.addmaterialForm.validate().then((valid) => {
        if (valid) {
          if (this.addAttachmentmaterialBlock) {
            return;
          }
          if (this.addmaterialForm.attachmentList.length == 0) {
            return this.$message.error("请选择需要上传的文件");
          }
          this.addAttachmentmaterialBlock = true;
          let len = this.addmaterialForm.id.length;
          this.addmaterialForm.id = this.addmaterialForm.id[len - 1];
          this.api.fodderGroupInfo.addAttachment(this.addmaterialForm).then((res) => {
            if (res.success) {
              this.addAttachmentmaterialBlock = false;
              this.materialVisible = false;
              this.pageList();
              this.$refs.upload.clearFiles();
              this.$message.success(res.message);
            } else {
              this.addAttachmentmaterialBlock = false;
              this.$message.error(res.message);
            }
          });
        }
      });
    },

    /*---------------------------分组管理-------------------------*/
    getFodderGroupInfoTree () {
      if (this.searchFodderGroupForm.name == "") {
        this.searchFodderGroupForm.name = null;
      }
      this.api.fodderGroupInfo
        .getFodderGroupInfoTree(this.searchFodderGroupForm)
        .then((res) => {
          if (res.success) {
            this.fodderGroupInfoList = res.data;
            this.$nextTick(function () {
              this.$refs.tree.setCurrentKey(res.data[0].id);
              this.id = res.data[0].id;
              this.fodderGroupInfoName = res.data[0].name;
            });
            this.pageList();
          } else {
            this.$message.error(res.message);
          }
        });
    },
    addFodderGroupInfo () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.api.fodderGroupInfo.addFodderGroupInfo(this.addForm).then((res) => {
            if (res.success) {
              this.$message.success(res.message);
              this.getFodderGroupInfoTree();
              this.groupsVisible = false;
            } else {
              this.$message.error(res.message);
            }
          });
        }
      });
    },

    rename (row) {
      this.editGroupsForm = row;
      this.editGroupsVisible = true;
    },
    updateFodderGroupInfo () {
      if (this.updateFodderGroupInfoBlock) {
        return;
      }
      this.updateFodderGroupInfoBlock = true;
      this.$refs.editGroupsForm.validate().then((valid) => {
        if (valid) {
          this.api.fodderGroupInfo
            .updateFodderGroupInfo(this.editGroupsForm)
            .then((res) => {
              if (res.success) {
                this.$message.success(res.message);
                this.editGroupsVisible = false;
                this.updateFodderGroupInfoBlock = false;
                this.getFodderGroupInfoTree();
              } else {
                this.updateFodderGroupInfoBlock = false;
                this.$message.error(res.message);
              }
            });
        }
      });
    },

    deleteFodderGroupInfo (id) {
      this.api.fodderGroupInfo.deleteFodderGroupInfo({ id: id }).then((res) => {
        if (res.success) {
          this.$message.success(res.message);
          this.getFodderGroupInfoTree();
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
  mounted () {
    this.getFodderGroupInfoTree();
    this.api.attachment.checkCapacityExceeded({}).then(res => {
      this.canUp = res
    })
  },
  watch: {
    groupsVisible: function (newVal) {
      if (!newVal) {
        this.addForm.name = "";
      } else {
      }
    },
    materialVisible: function (newVal) {
      if (!newVal) {
        this.materialList = [];
      } else {
      }
    },
  },
};
</script>
<style scoped>
.span-ellipsis {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
}
.materialMaterial-left {
  width: 220px;
  border: 1px solid #eee;
  padding: 20px 0px;
  flex-shrink: 0;
}
.materialMaterial-right {
  width: 100%;
}
.materialMaterial-left-title {
  padding: 0 20px;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 15px;
}
.materialMaterial-left-input {
  padding: 0 20px;
  margin-bottom: 8px;
}
.iconPlus {
  float: right;
  font-size: 16px;
  font-weight: 600;
}
.materialMaterial-left-file {
  padding: 8px 20px;
  cursor: pointer;
}
.materialMaterial-left-file:hover {
  background: rgba(238, 245, 255, 1);
}
.materialMaterial-left-file_active {
  padding: 8px 20px;
  cursor: pointer;
  background: rgba(238, 245, 255, 1);
}
.materialMaterial-button {
  cursor: pointer;
  color: #4d94ff;
  padding: 2px 8px;
  border: 1px solid #4d94ff;
  margin-left: 10px;
  line-height: 22px;
}

.el-upload--picture-card {
  width: 80px !important;
  height: 80px;
  display: block;
}
.material_operation {
  float: right;
  color: #409eff;
  margin-right: 20px;
}
.photoMaterial-button {
  cursor: pointer;
  color: #4d94ff;
  padding: 2px 8px;
  border: 1px solid #4d94ff;
  margin-left: 10px;
  line-height: 22px;
}
</style>

<style lang="less" rel="stylesheet/less">
.materialMaterial {
  .el-upload-list {
    display: none !important;
  }
  .el-tree-node__content {
    height: 35px;
  }
  .avatar-uploader {
    display: flex;
    flex-wrap: wrap;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 80px;
    height: 80px;
    line-height: 80px;
  }
  .el-upload-list--picture-card .el-upload-list__item {
    width: 80px;
    height: 80px;
  }
  .el-upload-list--picture-card {
    display: flex;
    flex-wrap: wrap;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/materialCenter/material.vue